import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { Container } from '@mui/material';
import { BackButton } from '@marageti/z4-lib';
import VersionDetailView from './version-detail-view';
import { useEntityVersions } from '../use-entity-versions';
import { EntityType, AnyEntityVersion } from '../../types';

const VersionDetailContainer: React.FC = () => {
  const { entityType, id } = useParams<{ entityType: string; id: string }>();
  const [searchParams] = useSearchParams();
  const updateId = searchParams.get('updateId');
  const navigate = useNavigate();
  const { isLoading, error, fetchVersion } = useEntityVersions({});
  const [version, setVersion] = useState<AnyEntityVersion | null>(null);

  useEffect(() => {
    if (entityType && id && updateId) {
      fetchVersion(entityType as EntityType, id, updateId).then((result) => {
        setVersion(result);
      });
    }
  }, [entityType, id, updateId, fetchVersion]);

  return (
    <Container maxWidth="lg">
      <BackButton onClick={() => navigate('/settings/audit/versions')} sx={{ mb: 2 }} />
      <VersionDetailView
        version={version}
        entityType={entityType as EntityType}
        entityId={id || ''}
        isLoading={isLoading}
        error={error}
      />
    </Container>
  );
};

export default VersionDetailContainer;
